/**
 * The brand emblem's three ascending bars (Insight Analytics Brand Identity
 * 2), geometry verbatim from the landing site's inlined mark, at the
 * canonical 0.6/0.8/1.0 opacity stepping. Solid single-colour fill per the
 * flat rules — the landing's gradient stays on the landing.
 */

interface EmblemMarkProps {
  height: number;
  color?: string;
}

export const EmblemMark = ({ height, color = "#22c55e" }: EmblemMarkProps) => (
  <svg aria-hidden viewBox="0 0 672 570" fill="none" style={{ height, width: "auto" }}>
    <polygon
      fill={color}
      opacity={0.6}
      points="187.75 340.1 0 340.1 82.7 506.95 265.68 506.95 261.15 488.18 187.75 340.1"
    />
    <polygon
      fill={color}
      opacity={0.8}
      points="357.05 168.68 183.97 168.68 265.68 506.95 265.79 506.95 265.81 507.07 438.75 507.18 438.75 506.48 357.05 168.68"
    />
    <polygon
      fill={color}
      points="438.75 0 438.75 506.48 438.75 507.18 438.92 507.18 606.97 507.29 606.97 0 438.75 0"
    />
  </svg>
);
